import { ChevronRight } from "lucide-react"
import type { ReactNode } from "react"
import { cn } from "@/shared/lib/utils"
import { HapticLink } from "./haptic-link"
import { SectionHeading } from "./section-heading"

interface RailProps {
	title: string
	moreTo?: string
	children: ReactNode
	className?: string
	tourKey?: string
}

export function Rail({ title, moreTo, children, className, tourKey }: RailProps) {
	return (
		<section className={className} data-tour={tourKey}>
			<SectionHeading
				title={title}
				trailing={
					moreTo && (
						<HapticLink
							to={moreTo}
							className="inline-flex shrink-0 items-center text-sm text-muted-foreground transition-colors active:text-foreground"
						>
							Все
							<ChevronRight className="size-4" />
						</HapticLink>
					)
				}
			/>
			<div className="hide-scrollbar -mx-3 snap-x snap-mandatory overflow-x-auto scroll-px-3 px-3 sm:-mx-4 sm:scroll-px-4 sm:px-4">
				<div className="flex w-max gap-3 pb-1">{children}</div>
			</div>
		</section>
	)
}

export function RailItem({ children, className }: { children: ReactNode; className?: string }) {
	return <div className={cn("shrink-0 snap-start", className)}>{children}</div>
}
